<div class="transfer">
  <p>{{ 'reinvest.transfer3a.intro' | translate }}</p>
  <div class="transfer-3a-steps">
    <div *ngFor="let number of [1,2,3];" class="step">
      <div class="step-icon">
        <p>{{ number }}</p>
      </div>
      <p>{{ 'reinvest.transfer3a.step'+number | translate }}</p>
    </div>
  </div>
  <div class="transfer-cta">
    <button (click)="downloadTransferDoc()" class="ui-button full-width secondary" [disabled]="disabledDownloadLink">
      {{ 'reinvest.transfer3a.cta' | translate }}
    </button>
  </div>
  <p class="description">{{ 'reinvest.transfer3a.note' | translate }}</p>
</div>
